<template>
  <div>
    <div class="ui two column middle aligned stackable grid">
      <div class="column">
        <div class="ui path breadcrumb">
          <a id="path-root" class="section text-xl" @click="jump(-1)"><strong>{{ title }}</strong></a>
          <template v-for="(p, index) in path_levels">
            <div :key="'div-' + index" class="divider">/</div>
            <a :key="'path-' + index" class="section" @click="jump(index)">
              {{ p }}
            </a>
          </template>
        </div>
      </div>
      <TaskIndicator v-if="!hideTasks" class="column"/>
    </div>
    <FileSearch v-show="show_search" :path="path" :space="space"
                ref="fileSearch"
                :search_query="search_query"
                @download="download"
                @goto="search_goto"
                @del="del"
                @click_entry="click_entry"
                @close="show_search=false; in_search_goto=false;" />
    <div v-show="!show_search">
      <div class="ui two column middle aligned stackable grid tools">
        <div v-if="readonly" class="column">
          <button class="ui small labeled primary icon button topaction" :disabled="!num_checked" @click="download_checked">
            <i class="download icon"></i>
            批量下载
          </button>
        </div>
        <div v-else class="column">
          <div class="buttons topaction">
            <div id="add-dropdown" class="ui small teal dropdown button add">
              <i class="plus icon"></i>
              添加
              <i class="dropdown icon"></i>
              <div class="menu">
                <label class="item" for="upload">
                  <i class="upload icon"></i>
                  上传文件
                </label>
                <label v-if="has_dir_upload" class="item" for="upload-dir">
                  <i class="folder icon"></i>
                  上传文件夹
                </label>
                <div class="divider"></div>
                <div class="item" @click="show_modal('new-dir-modal')" id="new-dir">
                  <i class="folder plus icon"></i>
                  新建文件夹
                  <Modal id="new-dir-modal" title="新建文件夹" size="tiny" @cancel="new_dir_name=''" @ok="mkdir">
                    <div class="ui input fluid">
                      <input placeholder="请输入新文件夹的名称..." type="text" v-model="new_dir_name"
                             id="new-dir-name" name="new-dir-name"
                             @keyup.enter="hide_modal('new-dir-modal'); mkdir()"/>
                    </div>
                  </Modal>
                </div>
              </div>
            </div>
            <div class="ui icon small buttons batchops topaction">
              <button class="ui download button" data-tooltip="下载" :disabled="!num_checked"
                      @click="download_checked">
                <i class="download icon"></i>
              </button>
              <button class="ui move button" data-tooltip="移动" :disabled="!num_checked"
                      @click="move_checked_start">
                <i class="arrows alternate icon"></i>
              </button>
              <button class="ui copy button" data-tooltip="复制" :disabled="!num_checked"
                      @click="copy_checked_start">
                <i class="copy outline icon"></i>
              </button>
              <button id="trash" class="ui delete button" data-tooltip="删除" :disabled="!num_checked" @click="show_modal('delete-confirm')">
                <i class="ui text trash icon"></i>
                <Modal id="delete-confirm" title="删除" :message="'确认删除'+ num_checked + '个文件吗？'" @ok="delete_checked" />
              </button>
            </div>
            <button class="ui icon small rename batchops button topaction" :disabled="num_checked!=1"
                    data-tooltip="重命名" @click="rename_checked">
              <i class="pencil icon"></i>
            </button>
            <div class="ui icon small simple dropdown button topaction">
              <i class="cog icon"></i>
              <i class="dropdown icon"></i>
              <div class="menu">
                <a class="item" @click="show_modal('change-passphrase')">
                  <i class="key icon"></i>
                  修改加密密钥
                </a>
                <Modal id="change-passphrase" hide_footer="true" size="tiny" title="修改加密密钥">
                  <div class="ui form">
                    <div class="field">
                      <label>输入当前密钥</label>
                      <input id="cur_passphrase" name="cur_passphrase" type="password" v-model="cur_passphrase">
                    </div>
                    <div class="field">
                      <label>输入新的密钥</label>
                      <input id="new_passphrase" name="new_passphrase" type="password" v-model="new_passphrase">
                    </div>
                    <div class="field">
                      <label>再次输入新的密钥</label>
                      <input id="new_passphrase_repeat" name="new_passphrase_repeat" type="password" v-model="new_passphrase_repeat">
                    </div>
                    <button class="ui teal button" id="change_passphrase" @click="change_passphrase">修改</button>
                    <button class="ui button" @click="cancel_change_passphrase">取消</button>
                  </div>
                </Modal>
                <DirSelectModal ref="dirSelectModal" id="dir-select-modal"/>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="ui small fluid action input" :class="{ focus: search_query.length > 0 }">
            <input id="file-search" name="file-search" v-model.trim="search_query" class="search" type="search" @keyup.enter="search" placeholder="按文件名搜索" />
            <div class="ui icon button" :class="{ teal: search_query }" @click="search">
              <i class="search icon"></i>
              <span class="ml-1">
                搜索
              </span>
            </div>
          </div>
        </div>
      </div>
      <table class="ui very basic compact unstackable table filelist nowrap">
        <thead>
          <tr>
            <th class="ten wide">
              <a class="checker" id="toggle-all" @click="toggle_all">
                <i v-if="!all_checked" class="square outline icon" style="opacity: 0.2"></i>
                <i v-else class="check square outline icon blue"></i>
              </a>
              <a @click="toggle_sort('name')">
                文件名
                <span v-if="sort.key == 'name'">
                  <i v-if="sort.ascending" class="arrow up icon ui text grey"></i>
                  <i v-else class="arrow down icon ui text grey"></i>
                </span>
              </a>
              <span class="font-normal">
                {{ children.length }}个文件
                <span v-if="num_checked"> - 选中{{ num_checked }}个</span>
              </span>
              <span class="ui basic teal label" v-if="search_query && !in_search_goto">
                按文件名过滤：{{ search_query }}
                <a @click="search_query=''">
                  <i class="times icon"></i>
                </a>
              </span>
              <a v-if="search_query && !in_search_goto" class="ui teal label" @click="search">
                搜索子目录
              </a>
            </th>
            <th class="one wide hidden md:table-cell"></th>
            <th class="two wide hidden lg:table-cell">
              <a @click="toggle_sort('size')">
                大小
                <span v-if="sort.key == 'size'">
                  <i v-if="sort.ascending" class="arrow up icon ui text grey"></i>
                  <i v-else class="arrow down icon ui text grey"></i>
                </span>
              </a>
            </th>
            <th class="three wide hidden lg:table-cell">
              <a @click="toggle_sort('mtime')">
                修改时间
                <span v-if="sort.key == 'mtime'">
                  <i v-if="sort.ascending" class="arrow up icon ui text grey"></i>
                  <i v-else class="arrow down icon ui text grey"></i>
                </span>
              </a>
            </th>
          </tr>
        </thead>
        <tbody v-if="!$asyncComputed.dir.updating">
          <tr v-if="this.path.length > 1 || this.in_search_goto">
            <td class="back">
              <a v-if="this.path.length > 1" class="ui label" @click="jump(path_levels.length - 2)">
                <i class="reply icon"></i>
                返回上一级目录
              </a>
              <a v-if="in_search_goto" class="ui teal label" @click="show_search=true; in_search_goto=false;">
                返回搜索结果
              </a>
            </td>
            <td class="hidden md:table-cell"></td>
            <td class="hidden lg:table-cell"></td>
            <td class="hidden lg:table-cell"></td>
          </tr>
          <EntryRow v-for="e in children"
                    :space="space" :entry="e"
                    :key="e.obj_id"
                    :checked="e.checked"
                    :readonly="readonly"
                    @del="del([$event])"
                    @toggle_check="toggle(e)"
                    @select="select(e, $event)"
                    @click="click_entry"
                    @enter="enter"
                    @download="download"/>
        </tbody>
      </table>
      <Placeholder v-if="$asyncComputed.dir.updating"/>
      <div v-else-if="!children.length" class="ui info message">
        没有文件
      </div>
      <input type="file" multiple id="upload" name="upload" ref="upload" @change="handle_upload" style="display:none;">
      <input type="file" multiple webkitdirectory id="upload-dir" name="upload-dir" @change="handle_upload" style="display:none;">
    </div>
    <FilePreviewModal id="file-preview" ref="filePreview" @download="download($event)" />
  </div>
</template>

<script>
import Modal from './modal.vue'
import EntryRow from './entry-row.vue'
import FilePreviewModal from './file-preview-modal'
import DirSelectModal from './dir-select-modal.vue'
import TaskIndicator from './task-indicator'
import FileSearch from './file-search'
import Placeholder from './placeholder'

export default {
  name: 'FileManager',
  props: {
    title: String,
    chroot: String,
    space: Object,
    readonly: Boolean,
    hideTasks: Boolean,
  },
  components: {
    Modal,
    EntryRow,
    FilePreviewModal,
    DirSelectModal,
    TaskIndicator,
    FileSearch,
    Placeholder,
  },
  data: function () {
    return {
      sort: {
        key: "name",
        ascending: true,
      },
      all_checked: false,
      dragging_file: false,
      path: '/',
      new_dir_name: "",
      new_name: "",
      chosen_dir: null,
      opening: false,
      search_query: '',
      cur_passphrase: '',
      new_passphrase: '',
      new_passphrase_repeat: '',
      num_checked: 0,
      show_search: false,
      in_search_goto: false,
      selected: null,
      checked_paths: new Map(),
    };
  },
  computed: {
    path_levels() {
      return this.path.split("/").filter(x => x.length > 0);
    },
    empty() {
      return !(this.dir && this.children && this.children.length);
    },
    path_in_space() {
      if (!this.chroot) {
        return this.path;
      }
      return this.space.path_join(this.chroot, this.path);
    },
    children() {
      if (!this.dir || !this.dir.children) return [];
      var visible = this.dir.children;
      visible = visible.filter(x => x.path != "/.mods");
      visible = this.apply_search_query(visible);
      process.nextTick(this.update_num_checked.bind(this));
      return visible.map(x => {
        this.set_checked(x, this.should_check(x));
        x.is_fav = this.$store.state.favs.has(x.path);
        return x;
      }).sort(this.cmp_entry.bind(this));
    },
    checked_entries() {
      if (!this.children) return null;
      return this.children.filter(x => x.checked);
    },
    in_sync() {
      return this.space ? this.space.is_synced : true;
    },
  },
  asyncComputed: {
    async dir() {
      if (!this.space) {
        return null;
      }
      if (!this.path) {
        this.set_path(this.space.root.path)
      }
      var node = await this.space.fetch(this.path_in_space);
      if (node) {
        await node.populate();
      }
      return node;
    },
  },
  filters: {
  },
  methods: {
    set_checked(x, checked) {
      x.checked = checked;
      if (checked) {
        this.checked_paths.set(x.path, true);
      } else {
        this.checked_paths.delete(x.path);
      }
    },
    should_check(x) {
      if (this.checked_paths.get(x.path)) return true;
      var selected = this.$route.query.selected || "";
      for (var f of selected.split('|')) {
        if (f.length && f == x.name)
          return true;
      }
      return false;
    },
    show_dir_select_modal(done) {
      this.$refs.dirSelectModal.reset();
      this.$refs.dirSelectModal.show(done);
    },
    move_checked_start() {
      this.show_dir_select_modal(dst => {
        this.move_checked(dst);
      });
    },
    copy_checked_start() {
      this.show_dir_select_modal(dst => {
        this.copy_checked(dst);
      });
    },
    search_goto(e) {
      this.show_search = false;
      this.in_search_goto = true;
      this.set_path(this.space.dirname(e.path), e.name)
    },
    search() {
      if (!this.search_query) {
        return;
      }
      this.show_search = true;
      this.$refs.fileSearch.search();
    },
    toggle_sort(key) {
      if (this.sort.key == key) {
        this.sort.ascending = !this.sort.ascending;
      } else {
        this.sort.ascending = 0;
        this.sort.key = key;
      }
    },
    cmp_entry(a, b) {
      var af = this.sort.ascending ? 1 : -1;
      var key = this.sort.key;
      if (key == 'name') {
        if (a.isdir != b.isdir) {
          return af * (a.isdir ? -1 : 1);
        }
        return af * a.name.localeCompare(b.name);
      } else if (key == 'size') {
        return af * (a.size - b.size);
      } else {
        return af * (a.mtime - b.mtime);
      }
    },
    update_num_checked() {
      this.num_checked = this.children.filter(c => c.checked).length;
      this.all_checked = this.num_checked && this.children.length == this.num_checked;
      this.$forceUpdate();
    },
    select(e, entry_row) {
      console.log("select", e, entry_row);
      this.selected = entry_row;
      this.children.forEach(x => {
        this.set_checked(x, x.obj_id == e.obj_id);
      });
      this.set_path(this.path, e.name, false);
      this.update_num_checked();
    },
    toggle(e) {
      this.set_checked(e, !e.checked);
      if (!e.checked) {
        this.all_checked = false;
      }
      this.update_num_checked();
    },
    toggle_all() {
      if (this.all_checked) {
        this.all_checked = false;
        this.children.forEach(c => { this.set_checked(c, false); });
      } else {
        this.all_checked = true;
        this.children.forEach(c => { this.set_checked(c, true); });
      }
      this.update_num_checked();
    },
    cancel_change_passphrase() {
      this.hide_modal('change-passphrase');
      this.cur_passphrase = '';
      this.new_passphrase = '';
      this.new_passphrase_repeat = '';
    },
    async change_passphrase(e) {
      e.preventDefault();
      if (!this.new_passphrase) {
        this.show_error("新密钥不能为空");
        return;
      }
      if (this.new_passphrase != this.new_passphrase_repeat) {
        this.show_error("新密钥两次输入不一致");
        return;
      }
      try {
        await this.check_passphrase(this.cur_passphrase);
        await this.space.set_passphrase(this.new_passphrase);
        this.show_success("加密密钥已修改");
        this.hide_modal('change-passphrase');
        this.$store.commit('set_default_passphrase', this.new_passphrase);
      } catch (e) {
        var msg = e.message;
        if (msg == "EKEYREJECTED") {
          msg = "原密钥输入错误";
        } else {
          msg = "未知错误";
        }
        this.show_error("加密密钥修改失败: " + msg);
      }
    },
    check_passphrase(p) {
      return this.client.open_space(this.space.name, p);
    },
    apply_search_query(entries) {
      if (this.in_search_goto) {
        return entries;
      }
      var q = this.search_query.split(' ').filter(x => x.length);
      var r = entries;
      for (var t of q) {
        r = r.filter(x => x.name.toLowerCase().includes(t.toLowerCase()));
      }
      return r;
    },
    dragover() {
      this.dragging_file = true;
    },
    dragleave() {
      this.dragging_file = false;
    },
    drop(event) {
      this.dragging_file = false;
      this.upload(event.dataTransfer.files);
    },
    collect_checked() {
      var r = this.children.filter(x => {
        var c = x.checked;
        x.checked = false;
        return c;
      });
      this.update_num_checked();
      return r;
    },
    del(items) {
      this.$gtag.event('delete-single', {
        event_category: 'user-action',
      });
      return items.forEach(x => {
        var path = this.space.path_join(this.path_in_space, x.name);
        this.space.remove(path).catch(e => {
          console.log(e);
          this.show_error("无法删除文件夹:" + x.name);
        });
      });
    },
    rename_checked() {
      this.$gtag.event('rename-selected', {
        event_category: 'user-action',
      });
      var checked = this.children.filter(x => x.checked);
      if (checked.length != 1 || !this.selected) {
        return;
      }
      this.selected.rename_start();
    },
    delete_checked() {
      this.$gtag.event('delete-selected', {
        event_category: 'user-action',
      });
      return this.del(this.collect_checked());
    },
    search_enter(e) {
      this.show_search = false;
      this.in_search_goto = true;
      this.set_path(e.path);
    },
    click_entry(e) {
      if (e.type == "dir") {
        this.$gtag.event('cd', {
          event_category: 'user-action',
        });
        if (this.show_search) {
          this.search_enter(e);
        } else {
          this.cd(e.name);
        }
      } else {
        this.$gtag.event('preview', {
          event_category: 'user-action',
        });
        this.show_preview(e);
      }
    },
    enter(e) {
      if (e.type == "dir") {
        this.$gtag.event('cd', {
          event_category: 'user-action',
          event_label: 'double-click',
        });
        this.cd(e.name);
      }
    },
    show_preview(e) {
      this.$refs.filePreview.reload(e)
      this.show_modal("file-preview");
    },
    download(e) {
      this.$store.commit("download", {
        entries: [e],
        on_error: t => {
          this.show_error(t.name + "下载失败：" + this.error_text(t.error));
        },
      });
    },
    download_checked() {
      this.$gtag.event('download-selected', {
        event_category: 'user-action',
      });
      this.$store.commit("download", {
        entries: this.collect_checked(),
      });
    },
    cd(e) {
      this.set_path(this.space.path_join(this.path, e))
    },
    jump(n) {
      this.set_path('/' + this.path_levels.slice(0, n + 1).join('/'))
    },
    mkdir() {
      this.$gtag.event('mkdir', {
        event_category: 'user-action',
      });
      if (this.new_dir_name.length < 1) {
        this.show_error("文件夹名称不能为空");
        return;
      }
      for (var c of this.dir.children) {
        if (c.name == this.new_dir_name) {
          if (c.isdir) {
            this.show_error("已存在同名文件夹: " + this.new_dir_name);
          } else {
            this.show_error("已存在同名文件: " + this.new_dir_name);
          }
          this.new_dir_name = "";
          return;
        }
      }
      this.space.mkdir(this.space.path_join(this.path_in_space, this.new_dir_name)).catch(e => {
        this.show_error(e);
      });
      this.new_dir_name = "";
    },
    upload(files) {
      var ok_files = [];
      var existing_file_names = [];
      files.forEach(f => {
        if (f.webkitRelativePath) {
          ok_files.push(f);
          return;
        }
        if (this.dir.children.find(c => c.name == f.name)) {
          existing_file_names.push(f.name);
          return;
        }
        ok_files.push(f);
      });
      if (existing_file_names.length > 0) {
        var msg = existing_file_names.length + "个文件无法上传，已存在同名文件";
        this.show_error(msg);
      }
      this.$store.commit("upload", {
        space: this.space,
        path: this.path,
        files: ok_files,
        on_error: t => {
          this.show_error(t.name + " 上传失败：" + this.error_text(t.error));
        },
      });
    },
    handle_upload(e) {
      this.$gtag.event('upload-file', {
        event_category: 'user-action',
      });
      var r = this.upload(e.target.files);
      e.target.value = "";
      return r;
    },
    async copy_checked(dst) {
      this.$gtag.event('copy-selected', {
        event_category: 'user-action',
      });
      try {
        var tasks = this.collect_checked().map(x => {
          var path = this.space.path_join(this.path_in_space, x.name);
          return this.space.copy(path, dst);
        });
        await Promise.all(tasks);
      } catch (e) {
        this.show_error("无法复制文件: " + this.error_text(e));
      }
    },
    async move_checked(dst) {
      this.$gtag.event('move-selected', {
        event_category: 'user-action',
      });
      try {
        var tasks = this.collect_checked().map(x => {
          var path = this.space.path_join(this.path_in_space, x.name);
          return this.space.move(path, dst);
        });
        await Promise.all(tasks);
      } catch (e) {
        this.show_error("无法移动文件: " + this.error_text(e));
      }
    },
    set_path(path, selected, scroll=true) {
      this.path = path;
      this.checked_paths.clear();
      // Make a clean copy of the current query
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries.path = this.path;
      if (selected) {
        queries.selected = selected;
      } else {
        delete queries.selected;
      }
      this.$router.replace({ query: queries });
      if (scroll) {
        process.nextTick(this.scroll_to_selected.bind(this));
      }
    },
    scroll_to_selected() {
      var x = this.$("tr.entry.checked").get(0);
      if (x) {
        console.log(x);
        x.scrollIntoView({
          block: 'center',
        });
      }
    },
    /* end of methods */
  },
  mounted() {
    this.path = this.$route.query.path || "/";
    this.$("#add-dropdown").dropdown({
      on: 'click',
    });
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#trash:hover {
  background-color: #d00000;
  color: white;
}
.add.button {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
.lg .tools {
  margin-top: 5px !important;
  margin-bottom: 10px !important;
}
.sm .tools {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.path.breadcrumb .divider {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
.filelist td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.batchops {
  margin-right: 0.2rem !important;
}
a.checker {
  padding: 3px;
}
.sm a.checker {
  font-size: large;
}
td.back {
  padding-left: 2rem !important;
}
.topaction {
  margin-top: 5px;
}
</style>
